import { Injectable } from '@angular/core';
import moment from 'moment';
import { AuthService } from 'src/app/@auth/auth.service';
import { v4 as uuidv4 } from 'uuid';
import { RxCluDocLigneDocumentType } from '../../m-remdocs/@schemas/clu_docligne.schema';
import { CLU_TICKET_STATUS, CluTickItem } from '../@models/clutick.model';
import { RxCluZJetDocumentType } from '../@schemas/clu_jet.schema';
import { RxCluTickReglementDocumentType } from '../@schemas/clu_tickreglement.schema';
import { RxPDeviceDocumentType } from '../@schemas/p_device.schema';
import { RxCluTickEnteteDocument } from './m-cashdesk-core-rxdb';
import { CashDeskCoreRxDbService } from './m-cashdesk-core-rxdb.service';
import { TauriService } from 'src/app/services/tauri/tauri.service';

@Injectable()
export class CashDeskZCluJetService {

    constructor(
      private _authService : AuthService,
      private _cashDeskRxDbService : CashDeskCoreRxDbService,
      private _tauriService: TauriService
    ) {

    }

    private async doGetGenerateDefaultJetItem_JetFn(JET_EVT_CODE : string, JET_EVT_LIB : string, JET_EVT_DATA : string) : Promise<RxCluZJetDocumentType | null> {
        const authSessionDto: any = this._authService.authenticatedSession$.value!;
        if(!authSessionDto || !authSessionDto.SITE_ITEM || !authSessionDto.FO_PARAMS || !authSessionDto.FO_PARAMS.M_CAISSE_PERM || !authSessionDto.FO_PARAMS.M_CAISSE_PERM.CASHIER_ITEM) return null;

        let DEVICE : RxPDeviceDocumentType | null = null;
        if (this._tauriService.isTauri) {
          try { DEVICE = await this._tauriService.doGetPDeviceItemByCaissegidAction(localStorage.getItem('LS_FE_AUTH_CASHDESK_GID')!); } catch {}
        } else {
          const query_DEVICE = this._cashDeskRxDbService.db.pdevice.findOne({ selector: { "CAISSEGID": { "$eq": localStorage.getItem('LS_FE_AUTH_CASHDESK_GID') } }});
          DEVICE = await query_DEVICE.exec();
        }
        if(!DEVICE) return null;

        let JET_EVT_DATA_F = JET_EVT_DATA ?? '';
        if(JET_EVT_DATA_F.length > 300) { JET_EVT_DATA_F = JET_EVT_DATA_F.substring(0, 300); }
        let _jetItem = {
            JET_GID : uuidv4(),
            JET_DATEEVENT : moment().local().format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z',
            JET_EVT_CODE : JET_EVT_CODE,
            JET_EVT_LIB : JET_EVT_LIB,
            JET_EVT_DATA : JET_EVT_DATA_F,
            USER_GID : authSessionDto.ID,
            MD_SITEGID : authSessionDto.SITE_ITEM.SITEGID,
            MD_SITE_LIB : authSessionDto.SITE_ITEM.S_DENOMINATION,
            MD_CAISSE : localStorage.getItem('LS_FE_AUTH_CASHDESK_GID') || '',
            MD_CAISSE_LIB : DEVICE!.C_NO + ' ' + DEVICE!.C_DENOMINATION,
            MD_CAISSIERGID : authSessionDto.FO_PARAMS.M_CAISSE_PERM.CASHIER_ITEM.CAISSIERGID,
            MD_CAISSIER_LIB : authSessionDto.FO_PARAMS.M_CAISSE_PERM.CASHIER_ITEM.CLU_USERLIB,
            MD_CAISSE_SESSION : DEVICE!.CAISSE_SESSION || '',
            MD_SITE_SESSION : DEVICE!.SITE_SESSION || '',
            MD_LOCALGID : DEVICE!.CAISSE_SESSION_OUVERTURE_PAR_LOCALGID ?? '',
            ZSYNCUP_FLAG : 0,
            ZSYNCUP_STATUS : 'pending',
            ZSYNCUP_ERROR_MESSAGE : '',
            ZSYNCUP_DATETIME : '',
            ZSYNCUP_FEEDID : ''
        };
        return _jetItem;
    }

    async doLogCashDeskOpeningEvent_JetFn(_deviceRes : RxPDeviceDocumentType){
        let JET_EVT_CODE : string = '80'; let JET_EVT_LIB : string = 'Ouverture session caisse';
        let JET_EVT_DATA : string = JET_EVT_LIB;
        let _jetItem = await this.doGetGenerateDefaultJetItem_JetFn(JET_EVT_CODE, JET_EVT_LIB, JET_EVT_DATA);
        if(!_jetItem) return;
        _jetItem.MD_CAISSE_SESSION = _deviceRes.CAISSE_SESSION;
        _jetItem.MD_SITE_SESSION = _deviceRes.SITE_SESSION;
        _jetItem.MD_LOCALGID = _deviceRes.CAISSE_SESSION_OUVERTURE_PAR_LOCALGID ?? '';
        if(!_jetItem || !_jetItem.MD_CAISSE_SESSION) return;
        await this._cashDeskRxDbService.db.clujet.insert(_jetItem);
        await this.doLogCashDeskOpeningFondCaisseEvent_JetFn(_deviceRes);
    }

    async doLogCashDeskOpeningFondCaisseEvent_JetFn(_deviceRes : RxPDeviceDocumentType){
        let JET_EVT_CODE : string = '170'; let JET_EVT_LIB : string = 'Traitement de fond de caisse à l\'ouverture';
        let JET_EVT_DATA : string = JET_EVT_LIB + ' [Fond caisse : ' + (_deviceRes.CAISSE_SESSION_OUVERTURE_FOND_CAISSE ?? 0)?.toFixed(2) + ']';
        let _jetItem = await this.doGetGenerateDefaultJetItem_JetFn(JET_EVT_CODE, JET_EVT_LIB, JET_EVT_DATA);
        if(!_jetItem) return;
        _jetItem.MD_CAISSE_SESSION = _deviceRes.CAISSE_SESSION;
        _jetItem.MD_SITE_SESSION = _deviceRes.SITE_SESSION;
        _jetItem.MD_LOCALGID = _deviceRes.CAISSE_SESSION_OUVERTURE_PAR_LOCALGID ?? '';
        if(!_jetItem || !_jetItem.MD_CAISSE_SESSION) return;
        await this._cashDeskRxDbService.db.clujet.insert(_jetItem);
    }

    async doLogCashDeskOfflineEvent_JetFn(){
        let JET_EVT_CODE : string = '70'; let JET_EVT_LIB : string = 'Début de mode dégradé [Hors connexion]';
        let JET_EVT_DATA : string = JET_EVT_LIB;
        let _jetItem = await this.doGetGenerateDefaultJetItem_JetFn(JET_EVT_CODE, JET_EVT_LIB, JET_EVT_DATA);
        if(!_jetItem || !_jetItem.MD_CAISSE_SESSION) return;
        await this._cashDeskRxDbService.db.clujet.insert(_jetItem);
    }

    async doLogCashDeskOnlineEvent_JetFn(){
        let JET_EVT_CODE : string = '120'; let JET_EVT_LIB : string = 'Fin de mode dégradé';
        let JET_EVT_DATA : string = JET_EVT_LIB;
        let _jetItem = await this.doGetGenerateDefaultJetItem_JetFn(JET_EVT_CODE, JET_EVT_LIB, JET_EVT_DATA);
        if(!_jetItem || !_jetItem.MD_CAISSE_SESSION) return;
        await this._cashDeskRxDbService.db.clujet.insert(_jetItem);
        await this.doLogCashDeskAfterOnlineCentralisationDonneesEvent_JetFn();
    }

    async doLogCashDeskAfterOnlineCentralisationDonneesEvent_JetFn(){
        let JET_EVT_CODE : string = '125'; let JET_EVT_LIB : string = 'Centralisation des données après fin de mode dégradé';
        let JET_EVT_DATA : string = JET_EVT_LIB;
        let _jetItem = await this.doGetGenerateDefaultJetItem_JetFn(JET_EVT_CODE, JET_EVT_LIB, JET_EVT_DATA);
        if(!_jetItem || !_jetItem.MD_CAISSE_SESSION) return;
        await this._cashDeskRxDbService.db.clujet.insert(_jetItem);
    }

    async doLogCashDeskCancelNotClosedTicketEvent_JetFn(_cluTickItem : CluTickItem){
        let JET_EVT_CODE : string = '320'; let JET_EVT_LIB : string = 'Abandon opération vente non encore enregistrée';
        let JET_EVT_DATA : string = JET_EVT_LIB + '[Ticket ' + _cluTickItem.ENTETE.DO_PIECE_INTERNAL + ']';
        let _jetItem = await this.doGetGenerateDefaultJetItem_JetFn(JET_EVT_CODE, JET_EVT_LIB, JET_EVT_DATA);
        if(!_jetItem || !_jetItem.MD_CAISSE_SESSION) return;
        await this._cashDeskRxDbService.db.clujet.insert(_jetItem);
    }

    async doLogCashDeskTicketSuppressionLigneEvent_JetFn(_rowItem : RxCluDocLigneDocumentType){
        if(!_rowItem.AR_REF || _rowItem.DL_VALORISE != 1) return;
        let JET_EVT_CODE : string = '323'; let JET_EVT_LIB : string = 'Annulation/modification d\'une ligne d\'article';
        let JET_EVT_DATA : string = 'Annulation ligne du Ticket [#' + _rowItem.DO_PIECE_INTERNAL + ' | ' + _rowItem.AR_REF + ' - ' + _rowItem.DL_DESIGN + ' | Qté : ' + _rowItem.DL_QTE.toFixed(2) + ' | Montant HT ' + _rowItem.DL_MONTANTHT.toFixed(2) + ']';
        if(JET_EVT_DATA.length > 300) { JET_EVT_DATA = 'Annulation ligne du Ticket [#' + _rowItem.DO_PIECE_INTERNAL + ' | ' + _rowItem.AR_REF + ' | Qté : ' + _rowItem.DL_QTE.toFixed(2) + ' | Montant HT ' + _rowItem.DL_MONTANTHT.toFixed(2) + ']'; }
        let _jetItem = await this.doGetGenerateDefaultJetItem_JetFn(JET_EVT_CODE, JET_EVT_LIB, JET_EVT_DATA);
        if(!_jetItem || !_jetItem.MD_CAISSE_SESSION) return;
        await this._cashDeskRxDbService.db.clujet.insert(_jetItem);
    }

    async doLogCashDeskTicketModificationLignePrixUnitaireHTEvent_JetFn(_rowItem : RxCluDocLigneDocumentType, _newValue : number){
        if(!_rowItem.AR_REF || _rowItem.DL_VALORISE != 1) return;
        let JET_EVT_CODE : string = '323'; let JET_EVT_LIB : string = 'Annulation/modification d\'une ligne d\'article';
        let JET_EVT_DATA : string = 'Modification PU HT Ligne du Ticket [#' + _rowItem.DO_PIECE_INTERNAL + ' | ' + _rowItem.AR_REF + ' - ' + _rowItem.DL_DESIGN + ' | Qté : ' + _rowItem.DL_QTE.toFixed(2) + ' | PU HT ' + _rowItem.DL_PRIXUNITAIRE.toFixed(2) + ' -> ' + _newValue.toFixed(2) + ']';
        if(JET_EVT_DATA.length > 300) { JET_EVT_DATA = 'Modification PU HT Ligne du Ticket [#' + _rowItem.DO_PIECE_INTERNAL + ' | ' + _rowItem.AR_REF + ' | Qté : ' + _rowItem.DL_QTE.toFixed(2) + ' | PU HT ' + _rowItem.DL_PRIXUNITAIRE.toFixed(2) + ' -> ' + _newValue.toFixed(2) + ']'; }
        let _jetItem = await this.doGetGenerateDefaultJetItem_JetFn(JET_EVT_CODE, JET_EVT_LIB, JET_EVT_DATA);
        if(!_jetItem || !_jetItem.MD_CAISSE_SESSION) return;
        await this._cashDeskRxDbService.db.clujet.insert(_jetItem);
    }

    async doLogCashDeskTicketModificationLignePrixUnitaireTTCEvent_JetFn(_rowItem : RxCluDocLigneDocumentType, _newValue : number){
        if(!_rowItem.AR_REF || _rowItem.DL_VALORISE != 1) return;
        let JET_EVT_CODE : string = '323'; let JET_EVT_LIB : string = 'Annulation/modification d\'une ligne d\'article';
        let JET_EVT_DATA : string = 'Modification PU TTC Ligne du Ticket [#' + _rowItem.DO_PIECE_INTERNAL + ' | ' + _rowItem.AR_REF + ' - ' + _rowItem.DL_DESIGN + ' | Qté : ' + _rowItem.DL_QTE.toFixed(2) + ' | PU TTC ' + _rowItem.DL_PUTTC!.toFixed(2) + ' -> ' + _newValue.toFixed(2) + ']';
        if(JET_EVT_DATA.length > 300) { JET_EVT_DATA = 'Modification PU TTC Ligne du Ticket [#' + _rowItem.DO_PIECE_INTERNAL + ' | ' + _rowItem.AR_REF + ' | Qté : ' + _rowItem.DL_QTE.toFixed(2) + ' | PU TTC ' + _rowItem.DL_PUTTC!.toFixed(2) + ' -> ' + _newValue.toFixed(2) + ']'; }
        let _jetItem = await this.doGetGenerateDefaultJetItem_JetFn(JET_EVT_CODE, JET_EVT_LIB, JET_EVT_DATA);
        if(!_jetItem || !_jetItem.MD_CAISSE_SESSION) return;
        await this._cashDeskRxDbService.db.clujet.insert(_jetItem);
    }

    async doLogCashDeskTicketModificationLigneQuantiteEnMinorationEvent_JetFn(_rowItem : RxCluDocLigneDocumentType, _newValue : number){
        if(!_rowItem.AR_REF || _rowItem.DL_VALORISE != 1) return;
        let JET_EVT_CODE : string = '323'; let JET_EVT_LIB : string = 'Annulation/modification d\'une ligne d\'article';
        let JET_EVT_DATA : string = 'Modification quantité en minoration Ligne du Ticket [#' + _rowItem.DO_PIECE_INTERNAL + ' | ' + _rowItem.AR_REF + ' - ' + _rowItem.DL_DESIGN + ' | Qté : ' + _rowItem.DL_QTE.toFixed(2) + ' -> ' + _newValue.toFixed(2) + ']';
        if(JET_EVT_DATA.length > 300) { JET_EVT_DATA = 'Modification quantité en minoration Ligne du Ticket [#' + _rowItem.DO_PIECE_INTERNAL + ' | ' + _rowItem.AR_REF + ' | Qté : ' + _rowItem.DL_QTE.toFixed(2) + ' -> ' + _newValue.toFixed(2) + ']'; }
        let _jetItem = await this.doGetGenerateDefaultJetItem_JetFn(JET_EVT_CODE, JET_EVT_LIB, JET_EVT_DATA);
        if(!_jetItem || !_jetItem.MD_CAISSE_SESSION) return;
        await this._cashDeskRxDbService.db.clujet.insert(_jetItem);
    }

    async doLogCashDeskTicketModificationRemiseEvent_JetFn(_rowItem : RxCluDocLigneDocumentType | undefined, _newValue : string){
        if(!_rowItem || !_rowItem.AR_REF || _rowItem.DL_VALORISE != 1) return;
        if(_newValue == '100%') {
            let JET_EVT_CODE : string = '328'; let JET_EVT_LIB : string = 'Passage d\'article en <offert>';
            let JET_EVT_DATA : string = 'Remise 100% Ligne du Ticket [#' + _rowItem.DO_PIECE_INTERNAL + ' | ' + _rowItem.AR_REF + ' - ' + _rowItem.DL_DESIGN + ' | Qté : ' + _rowItem.DL_QTE.toFixed(2) + ' | Remise : ' + _rowItem.DL_REMISE_LIB + ' -> ' + _newValue + ']';
            if(JET_EVT_DATA.length > 300) { JET_EVT_DATA = 'Remise 100% Ligne du Ticket [#' + _rowItem.DO_PIECE_INTERNAL + ' | ' + _rowItem.AR_REF + ' | Qté : ' + _rowItem.DL_QTE.toFixed(2) + ' | Remise : ' + _rowItem.DL_REMISE_LIB + ' -> ' + _newValue + ']'; }
            let _jetItem = await this.doGetGenerateDefaultJetItem_JetFn(JET_EVT_CODE, JET_EVT_LIB, JET_EVT_DATA);
            if(!_jetItem || !_jetItem.MD_CAISSE_SESSION) return;
            await this._cashDeskRxDbService.db.clujet.insert(_jetItem);
        }
        else {
            let JET_EVT_CODE : string = '323'; let JET_EVT_LIB : string = 'Annulation/modification d\'une ligne d\'article';
            let JET_EVT_DATA : string = 'Remise Ligne du Ticket [#' + _rowItem.DO_PIECE_INTERNAL + ' | ' + _rowItem.AR_REF + ' - ' + _rowItem.DL_DESIGN + ' | Qté : ' + _rowItem.DL_QTE.toFixed(2) + ' | Remise : ' + _rowItem.DL_REMISE_LIB + ' -> ' + _newValue + ']';
            if(JET_EVT_DATA.length > 300) { JET_EVT_DATA = 'Remise Ligne du Ticket [#' + _rowItem.DO_PIECE_INTERNAL + ' | ' + _rowItem.AR_REF + ' | Qté : ' + _rowItem.DL_QTE.toFixed(2) + ' | Remise : ' + _rowItem.DL_REMISE_LIB + ' -> ' + _newValue + ']'; }
            let _jetItem = await this.doGetGenerateDefaultJetItem_JetFn(JET_EVT_CODE, JET_EVT_LIB, JET_EVT_DATA);
            if(!_jetItem || !_jetItem.MD_CAISSE_SESSION) return;
            await this._cashDeskRxDbService.db.clujet.insert(_jetItem);
        }
    }

    async doLogCashDeskReturnLigneEvent_JetFn(_tReturnLigne : any | undefined){
        if(!_tReturnLigne) return;
        let JET_EVT_CODE : string = '326'; let JET_EVT_LIB : string = 'Retour(s) d\'article(s) après une émission d\'une note';
        let JET_EVT_DATA : string = 'Retour Ligne du Ticket [#' + _tReturnLigne.DO_PIECE_INTERNAL + ' | ' + _tReturnLigne.AR_REF + ' - ' + _tReturnLigne.DL_DESIGN + ' | Retour : ' + _tReturnLigne.RETURN_QTE.toFixed(2) + '/' + _tReturnLigne.DL_QTE.toFixed(2) + ']';
        if(JET_EVT_DATA.length > 300) { JET_EVT_DATA = 'Retour Ligne du Ticket [#' + _tReturnLigne.DO_PIECE_INTERNAL + ' | ' + _tReturnLigne.AR_REF + ' | Retour : ' + _tReturnLigne.RETURN_QTE.toFixed(2) + '/' + _tReturnLigne.DL_QTE.toFixed(2) + ']'; }
        let _jetItem = await this.doGetGenerateDefaultJetItem_JetFn(JET_EVT_CODE, JET_EVT_LIB, JET_EVT_DATA);
        if(!_jetItem || !_jetItem.MD_CAISSE_SESSION) return;
        await this._cashDeskRxDbService.db.clujet.insert(_jetItem);
    }

    async doLogCashDeskPaymentFixEvent_JetFn(_enItem : RxCluTickEnteteDocument, _rgItem : RxCluTickReglementDocumentType | null, _newValue : string){
        if(_rgItem == null || _enItem.ZTICKET_STATUS != CLU_TICKET_STATUS.TICKET_CLOSED) return;
        let JET_EVT_CODE : string = '420'; let JET_EVT_LIB : string = 'Changement du mode de règlement, après émission du ticket';
        const rgMontant = typeof _rgItem.RG_MONTANT === 'number' ? _rgItem.RG_MONTANT : parseFloat(_rgItem.RG_MONTANT);
        let JET_EVT_DATA : string = 'Mode de règlement Ticket [#' + _enItem.DO_PIECE_INTERNAL + ' | RG ' + rgMontant.toFixed(2) + ' du ' + _rgItem.RG_DATE + ' - ' + _rgItem.PK_ID + ' | Mode : ' + _rgItem.N_REGLEMENTLIB + ' -> ' + _newValue +']';
        let _jetItem = await this.doGetGenerateDefaultJetItem_JetFn(JET_EVT_CODE, JET_EVT_LIB, JET_EVT_DATA);
        if(!_jetItem || !_jetItem.MD_CAISSE_SESSION) return;
        await this._cashDeskRxDbService.db.clujet.insert(_jetItem);
    }

    async doLogCashDeskTicketPrintErrorEvent_JetFn(_cluTickItem : CluTickItem, _error : string){
        let JET_EVT_CODE : string = '150'; let JET_EVT_LIB : string = 'Imprimante indisponible';
        let _errorM = !_error ? '' : (_error.length > 120 ? _error.substring(0, 120) : _error);
        let JET_EVT_DATA : string = 'Imprimante indisponible / Mauvaise configuration agent. Ticket [#' + _cluTickItem.ENTETE.DO_PIECE_INTERNAL + ' | ' + _errorM + ']';
        let _jetItem = await this.doGetGenerateDefaultJetItem_JetFn(JET_EVT_CODE, JET_EVT_LIB, JET_EVT_DATA);
        if(!_jetItem || !_jetItem.MD_CAISSE_SESSION) return;
        await this._cashDeskRxDbService.db.clujet.insert(_jetItem);
    }

    async doLogCashDeskPotentielNotPrintedTicketEvent_JetFn(_cluTickItem : CluTickItem){
        if(_cluTickItem.ENTETE.DO_PRINT_NB && _cluTickItem.ENTETE.DO_PRINT_NB > 0) return;
        let JET_EVT_CODE : string = '950'; let JET_EVT_LIB : string = 'Aucune impression détectée';
        let JET_EVT_DATA : string = 'Aucune impression détectée. Ticket [#' + _cluTickItem.ENTETE.DO_PIECE_INTERNAL + ']';
        let _jetItem = await this.doGetGenerateDefaultJetItem_JetFn(JET_EVT_CODE, JET_EVT_LIB, JET_EVT_DATA);
        if(!_jetItem || !_jetItem.MD_CAISSE_SESSION) return;
        await this._cashDeskRxDbService.db.clujet.insert(_jetItem);
    }

    async doLogCashDeskSyncEvent_JetFn(){
        let JET_EVT_CODE : string = '260'; let JET_EVT_LIB : string = 'Initialisation des données';
        let JET_EVT_DATA : string = 'Synchronisation des structures & paramètres [Backoffice -> Caisse]';
        let _jetItem = await this.doGetGenerateDefaultJetItem_JetFn(JET_EVT_CODE, JET_EVT_LIB, JET_EVT_DATA);
        if(!_jetItem || !_jetItem.MD_CAISSE_SESSION) return;
        await this._cashDeskRxDbService.db.clujet.insert(_jetItem);
    }

    async doLogUserLoginEvent_JetFn() {
        let JET_EVT_CODE : string = '80'; let JET_EVT_LIB : string = 'Démarrage du terminal, connexion, ouverture de session';
        let JET_EVT_DATA : string = 'Connexion utilisateur';
        let _jetItem = await this.doGetGenerateDefaultJetItem_JetFn(JET_EVT_CODE, JET_EVT_LIB, JET_EVT_DATA);
        if(!_jetItem || !_jetItem.MD_CAISSE_SESSION) return;
        await this._cashDeskRxDbService.db.clujet.insert(_jetItem);
    }

    async doLogUserLogoutEvent_JetFn() {
        let JET_EVT_CODE : string = '40'; let JET_EVT_LIB : string = 'Arrêt du terminal, déconnexion, fermeture de session';
        let JET_EVT_DATA : string = 'Déconnexion utilisateur';
        let _jetItem = await this.doGetGenerateDefaultJetItem_JetFn(JET_EVT_CODE, JET_EVT_LIB, JET_EVT_DATA);
        if(!_jetItem || !_jetItem.MD_CAISSE_SESSION) return;
        await this._cashDeskRxDbService.db.clujet.insert(_jetItem);
    }
}
